import * as Sentry from "@sentry/browser";
import { Button, Col, Descriptions, Drawer, Row, Spin, Tag, message } from "antd";
import { FormInstance } from "antd/lib/form";
import { AxiosResponse } from "axios";
import moment from "moment";
import React, { Fragment, RefObject } from "react";
import { RouteComponentProps } from "react-router";
import { NavLink } from "react-router-dom";
import Card from "../components/Card";
// import NotesSection from "../components/NotesSection";
import RequestChangeLogs from "../components/RequestChangeLogs";
import {
  GET_FIXED_INCOME_REDEMPTION,
  //   GET_FIXED_INCOME_REDEMPTION_LOGS,
  MOVE_FIXED_INCOME_REDEMPTION_TO_STATE,
  GET_FIXED_INCOME_REQUEST_REASONS,
  //   ASSIGN_NOTE_TO_FIXED_INCOME_REDEMPTION,
} from "../gql/fixed-income-requests";
// import { CREATE_NOTE } from "../gql/notes";
import {
  ActiveDrawerContent,
  APIError,
  Changelog,
  FinancialInstitution,
  FixedIncomeRedemption,
  MultipleChangelog,
  Note,
  NotificationRecord,
  FixedIncomeRequestReason,
  SelectOptionsInterface,
  TransitionToNextState,
  User,
} from "../helpers/shared-interfaces";
import {
  capitalizeFirstLetter,
  formatSnakeCase,
  formatter,
  generateDisplayErrorMessage,
  generateStateButtonText,
  getStateButtonClass,
  getStateColor,
  handleValidationErrors,
  request,
  responseHandler,
  isTreasuryBillProduct,
} from "../helpers/utilities";
import ModalCreator from "../components/ModalCreator";
import { GET_FINANCIAL_INSTITUTIONS } from "../gql/general";
import { LoanRequestReasonUI } from "./ViewLoanRequest";
import { CalculatedBreakdownDisplay } from "../components/CalculatedBreakdownDisplay";
import {
  notificationColumns,
  NotificationRecordTableFactory,
} from "./NotificationRecords";

interface State {
  id: string;
  isLoading: boolean;
  fixedIncomeRedemption?: FixedIncomeRedemption;
  notes: Note[];
  currentNote?: Note;
  requestLogs: MultipleChangelog | Changelog[];
  showDrawer: boolean;
  activeDrawerContent: ActiveDrawerContent;
  showTicketForm: boolean;
  isTicketCreateLoading: boolean;
  selectedRedemptionNoteId: string;
  availableTransitionStates?: TransitionToNextState[];
  showReasonModal: boolean;
  selectedTransitionState: string;
  isReasonLoading: boolean;
  financialInstitutions: FinancialInstitution[];
  institutionOptions: FinancialInstitution[];
  selectedPaymentMethod?: string;
  fixedIncomeRequestReasons: FixedIncomeRequestReason[];
  selectedReasonId?: string;
}

interface RouteParams {
  id: string;
}

interface Props extends RouteComponentProps<RouteParams> {
  user: User;
}

export default class ViewFixedIncomeRedemption extends React.Component<
  Props,
  State
> {
  reference: RefObject<FormInstance>;
  ticketReference: RefObject<FormInstance>;
  reasonReference: RefObject<FormInstance>;

  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      fixedIncomeRedemption: undefined,
      isLoading: true,
      id: "",
      notes: [],
      currentNote: undefined,
      requestLogs: [],
      showDrawer: false,
      activeDrawerContent: "",
      showTicketForm: false,
      isTicketCreateLoading: false,
      selectedRedemptionNoteId: "",
      availableTransitionStates: [],
      showReasonModal: false,
      selectedTransitionState: "",
      isReasonLoading: false,
      financialInstitutions: [],
      institutionOptions: [],
      selectedPaymentMethod: undefined,
      fixedIncomeRequestReasons: [],
      selectedReasonId: undefined,
    };
    this.reference = React.createRef<FormInstance>();
    this.ticketReference = React.createRef<FormInstance>();
    this.reasonReference = React.createRef<FormInstance>();
  }

  componentDidMount(): void {
    this.setState(
      {
        id: this.props.match.params.id,
      },
      (): void => {
        this.getFixedIncomeRedemption();
        this.getFinancialInstitutions();
      },
    );
  }

  getFinancialInstitutions = async (): Promise<void> => {
    interface Response {
      data: {
        financialInstitutions: FinancialInstitution[];
      };
    }
    try {
      const {
        data: { data },
      }: AxiosResponse<Response> = await request({
        query: GET_FINANCIAL_INSTITUTIONS,
      });

      this.setState({
        financialInstitutions: data.financialInstitutions,
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  getFixedIncomeRedemption = (): void => {
    const { id } = this.state;
    interface Response {
      fixedIncomeRedemption: FixedIncomeRedemption;
    }

    this.setState({ isLoading: true });
    request({
      query: GET_FIXED_INCOME_REDEMPTION,
      variables: { id },
    })
      .then(({ data }: AxiosResponse<{ data: Response }>): void => {
        const { fixedIncomeRedemption } = data.data;
        this.setState({
          fixedIncomeRedemption: fixedIncomeRedemption,
          availableTransitionStates:
            fixedIncomeRedemption?.canTransitionToNextStates,
          //   notes:
          //     fixedIncomeRedemption?.fixedIncomeRedemptionNotes?.map(
          //       (fixedIncomeRedemptionNote: FixedIncomeRedemptionNote) => {
          //         return {
          //           ...fixedIncomeRedemptionNote.note,
          //           referenceId: fixedIncomeRedemptionNote.id,
          //         };
          //       },
          //     ) || [],
        });
      })
      .catch((error) => {
        message.error("Failed to load redemption");
        Sentry.captureException(error);
      })
      .finally((): void => {
        this.setState({ isLoading: false });
      });
  };

  //   getFixedIncomeRedemptionLogs = (): void => {
  //     const { fixedIncomeRedemption } = this.state;
  //     interface Response {
  //       fixedIncomeRedemptionChangeLogs: MultipleChangelog;
  //     }

  //     this.setState({ isLoading: true });
  //     request({
  //       query: GET_FIXED_INCOME_REDEMPTION_LOGS,
  //       variables: { fixedIncomeRedemptionId: fixedIncomeRedemption?.id },
  //     })
  //       .then(({ data }: AxiosResponse<{ data: Response }>): void => {
  //         this.setState({
  //           requestLogs: data?.data?.fixedIncomeRedemptionChangeLogs,
  //         });
  //       })
  //       .catch((error) => {
  //         message.error("Failed to load redemption logs");
  //         Sentry.captureException(error);
  //       })
  //       .finally(() => {
  //         this.setState({ isLoading: false });
  //       });
  //   };

  //   createNote = async (): Promise<void> => {
  //     const { user } = this.props;

  //     interface Response {
  //       fixedIncomeRedemptionNote: Note;
  //       note: Note;
  //     }

  //     const fieldsToBeValidated: string[] = ["description"];

  //     if (!this.reference.current) return;

  //     let data;

  //     try {
  //       data = await this.reference.current.validateFields(fieldsToBeValidated);
  //     } catch (error) {
  //       handleValidationErrors(error);
  //       return;
  //     }

  //     this.setState({ isLoading: true });

  //     try {
  //       const response: AxiosResponse = await request({
  //         query: CREATE_NOTE,
  //         variables: {
  //           description: data.description,
  //           userId: user.id,
  //         },
  //       });

  //       const { mutation, err } = responseHandler<Response>(
  //         response,
  //         "createNote",
  //       );

  //       if (err) {
  //         message.error(generateDisplayErrorMessage(err));
  //         this.setState({ isLoading: false });
  //         return;
  //       }

  //       if (mutation.note) {
  //         // await this.assignNoteToRedemption(mutation.note.id);
  //         message.success("Note created successfully");
  //       }

  //       this.reference.current.resetFields(fieldsToBeValidated);
  //     } catch (error) {
  //       message.error("Failed to create note");
  //       Sentry.captureException(error);
  //     } finally {
  //       this.setState({ isLoading: false });
  //     }
  //   };

  //   assignNoteToRedemption = (noteId: string): Promise<void> => {
  //     this.setState({ isLoading: true });

  //     interface Response {
  //       data: {
  //         assignNoteToFixedIncomeRedemption: {
  //           fixedIncomeRedemptionNote: {
  //             id: string;
  //             note: Note;
  //           };
  //         };
  //       };
  //     }

  //     return request({
  //       query: ASSIGN_NOTE_TO_FIXED_INCOME_REDEMPTION,
  //       variables: { noteId: noteId, fixedIncomeRedemptionId: this.state.id },
  //     })
  //       .then(({ data: { data } }: AxiosResponse<Response>): void => {
  //         let newNote = {
  //           ...data.assignNoteToFixedIncomeRedemption.fixedIncomeRedemptionNote
  //             .note,
  //           referenceId:
  //             data.assignNoteToFixedIncomeRedemption.fixedIncomeRedemptionNote.id,
  //         };

  //         this.setState({
  //           isLoading: false,
  //           currentNote: newNote,
  //           notes: [...this.state.notes, newNote],
  //         });
  //       })
  //       .catch((error) => {
  //         message.error("Failed to assign note");
  //         Sentry.captureException(error);
  //         this.setState({ isLoading: false });
  //       });
  //   };

  handleNoteUpdate = (updatedNotes: Note[]): void => {
    this.setState({ notes: updatedNotes });
  };

  toggleCreateTicket = (id: string): void => {
    this.setState((oldState) => ({
      selectedRedemptionNoteId: id,
      showTicketForm: !oldState.showTicketForm,
      currentNote: this.state.notes.find((note) => note.referenceId === id),
    }));
  };

  createTicket = async (): Promise<void> => {
    // Implement ticket creation similar to ViewFixedIncomeRequest if needed
    message.info("Ticket creation not yet implemented for redemptions");
  };

  executeDrawerQuery = (currentDrawer: ActiveDrawerContent): void => {
    switch (currentDrawer) {
      case "audits":
        // this.getFixedIncomeRedemptionLogs();
        break;
      case "notifierRecords":
        // No additional query needed, data is already loaded
        break;
      default:
        break;
    }
  };

  toggleDrawer = (activeDrawerContent: ActiveDrawerContent): (() => void) => {
    return (): void => {
      this.executeDrawerQuery(activeDrawerContent);
      this.setState({
        activeDrawerContent,
        showDrawer: !this.state.showDrawer,
      });
    };
  };

  getDrawerContent = (): JSX.Element => {
    const { requestLogs, activeDrawerContent, fixedIncomeRedemption, isLoading } = this.state;

    switch (activeDrawerContent) {
      case "audits":
        return <RequestChangeLogs data={requestLogs} isLoading={isLoading} />;
      case "notifierRecords":
        const records = fixedIncomeRedemption?.notifierRecords as
          | NotificationRecord[]
          | undefined;
        return (
          <Fragment>
            {records && records.length > 0 ? (
              NotificationRecordTableFactory(records, notificationColumns)
            ) : (
              <p style={{ textAlign: "center", color: "#999" }}>
                No notification records found
              </p>
            )}
          </Fragment>
        );
      default:
        return <Fragment />;
    }
  };

  getTitleBasedOnDrawerContent = (): React.ReactNode => {
    const { activeDrawerContent } = this.state;
    switch (activeDrawerContent) {
      case "audits":
        return "Redemption History";
      case "notifierRecords":
        return "Notification Records";
      default:
        return "Entity";
    }
  };

  toggleReasonModal = (): void => {
    this.setState((prevState) => ({
      showReasonModal: !prevState.showReasonModal,
    }));
  };

  handleReasonSelect = (reasonId: string): void => {
    this.setState({
      selectedReasonId: reasonId,
    });
  };

  saveStateReason = async (): Promise<void> => {
    if (this.state.isReasonLoading) {
      return;
    }

    const { selectedTransitionState, availableTransitionStates } = this.state;

    let data;

    if (!this.reasonReference.current) return;

    const selectedTransition = availableTransitionStates?.find(
      (t) => t.state === selectedTransitionState,
    );
    const requiresReason = selectedTransition?.reason_required || false;

    const fieldsToBeValidated = ["comment"];

    if (requiresReason) {
      fieldsToBeValidated.push("fixedIncomeRequestReasonId");
    }

    try {
      data = await this.reasonReference.current.validateFields(
        fieldsToBeValidated,
      );
    } catch (error) {
      handleValidationErrors(error as any);
      return;
    }

    this.setState({ isReasonLoading: true });

    try {
      await this.moveToNextState(data, selectedTransition);
    } catch (error) {
      Sentry.captureException(error);
      message.error(`Failed to process state transition - ${generateDisplayErrorMessage(error)}`);
    } finally {
      this.reasonReference.current.resetFields();
      this.setState({
        isReasonLoading: false,
        showReasonModal: false,
        selectedReasonId: undefined,
        fixedIncomeRequestReasons: [],
      });
    }
  };

  moveToNextState = async (
    data: any,
    transition: TransitionToNextState | undefined,
  ): Promise<void> => {
    interface Response {
      fixedIncomeRedemption: FixedIncomeRedemption;
      errors: APIError[];
    }

    const variables: any = {
      fixedIncomeRedemptionId: this.state.id,
      comment: data.comment,
      state: this.state.selectedTransitionState,
      event: transition?.event,
    };

    if (transition?.reason_required && data.fixedIncomeRequestReasonId) {
      variables.fixedIncomeRequestReasonId = data.fixedIncomeRequestReasonId;
    }

    const response: AxiosResponse = await request({
      query: MOVE_FIXED_INCOME_REDEMPTION_TO_STATE,
      variables,
    });

    const { err, mutation } = responseHandler<Response>(
      response,
      "moveFixedIncomeRedemptionToState",
    );

    const error = err || mutation.errors;

    if (mutation.fixedIncomeRedemption) {
      const newState = mutation.fixedIncomeRedemption.state;
      const stateMessages: Record<string, string> = {
        approved: "Redemption has been approved",
        processing: "Redemption is being processed",
        processed: "Redemption has been processed",
        payment_delayed: "Redemption payment has been delayed",
        paid: "Redemption has been paid",
        failed: "Redemption has failed",
        cancelled: "Redemption has been cancelled",
      };

      const successMessage = newState
        ? stateMessages[newState] ||
          `Redemption state updated to ${formatSnakeCase(newState)}`
        : "Redemption state updated successfully";

      message.success(successMessage);
      this.getFixedIncomeRedemption();
    } else if (error) {
      message.error(generateDisplayErrorMessage(error));
    } else {
      throw new Error(generateDisplayErrorMessage(error));
    }
  };

  handlePaymentMethodSelect = (paymentMethod: string): void => {
    let filteredInstitutions: FinancialInstitution[] = [];

    if (paymentMethod === "mobile_money") {
      filteredInstitutions = this.state.financialInstitutions.filter(
        (institution: FinancialInstitution): boolean => {
          return institution.institutionType === "mobile_money";
        },
      );
    } else if (
      paymentMethod === "bank_transfer" ||
      paymentMethod === "cheque"
    ) {
      filteredInstitutions = this.state.financialInstitutions.filter(
        (institution: FinancialInstitution): boolean => {
          return institution.institutionType === "bank";
        },
      );
    } else {
      filteredInstitutions = this.state.financialInstitutions;
    }

    this.setState({
      institutionOptions: filteredInstitutions,
      selectedPaymentMethod: paymentMethod,
    });
  };

  requestForReason = async (state: string): Promise<void> => {
    if (this.state.isReasonLoading) {
      return;
    }

    const selectedTransition = this.state.availableTransitionStates?.find(
      (t) => t.state === state,
    );

    if (selectedTransition?.reason_required) {
      interface Response {
        fixedIncomeRequestReasons: FixedIncomeRequestReason[];
        errors: APIError[];
      }

      this.setState({ isReasonLoading: true });

      try {
        request({
          query: GET_FIXED_INCOME_REQUEST_REASONS,
          variables: { state },
        })
          .then(({ data }: AxiosResponse<{ data: Response }>) => {
            this.setState({
              fixedIncomeRequestReasons: data.data.fixedIncomeRequestReasons,
              showReasonModal: true,
              selectedTransitionState: state,
            });
          })
          .finally(() => {
            this.setState({ isReasonLoading: false });
          });
      } catch (error) {
        message.error(`An error occurred, please try again later - ${generateDisplayErrorMessage(error)}`);
        Sentry.captureException(error);
        this.setState({ isReasonLoading: false });
      }
    } else {
      this.setState({
        showReasonModal: true,
        selectedTransitionState: state,
        fixedIncomeRequestReasons: [],
      });
    }
  };

  render(): JSX.Element | null {
    const {
      isLoading,
      fixedIncomeRedemption,
      availableTransitionStates,
      isReasonLoading,
      showReasonModal,
      selectedTransitionState,
      fixedIncomeRequestReasons,
      showDrawer,
    } = this.state;

    const isTreasuryBill = isTreasuryBillProduct(
      fixedIncomeRedemption?.fixedIncomeRequest?.product,
    );

    const reasons: SelectOptionsInterface[] = fixedIncomeRequestReasons?.map(
      (reason) => {
        return { id: reason.id, name: reason.description || "" };
      },
    );

    return (
      <Spin spinning={isLoading}>
        <Card>
          <Fragment>
            {ModalCreator({
              title: "Add Comment",
              okType: "primary",
              okText: "Submit",
              showModal: showReasonModal,
              onOkay: this.saveStateReason,
              toggleModal: this.toggleReasonModal,
              isLoading: isReasonLoading,
              okayButtonProps: {
                disabled: isReasonLoading,
              },
              inscription: LoanRequestReasonUI({
                reference: this.reasonReference,
                selectedTransitionState,
                availableTransitionStates,
                isLoading: isReasonLoading,
                commentRequired: true,
                financialInstitutions: this.state.financialInstitutions,
                handlePaymentMethodSelect: this.handlePaymentMethodSelect,
                institutionOptions: this.state.institutionOptions,
                selectedPaymentMethod: this.state.selectedPaymentMethod,
                reasons,
                handleReasonSelect: this.handleReasonSelect,
              }),
            })}
            <Row>
              <Col span={24}>
                {fixedIncomeRedemption && (
                  <Descriptions
                    title="Redemption Details"
                    extra={
                      <Row
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <Button
                          className="base-button"
                          onClick={this.toggleDrawer("notifierRecords")}
                        >
                          Notifications
                        </Button>
                        {/* <Button
                          className="base-button"
                          onClick={this.toggleDrawer("audits")}
                        >
                          Redemption History
                        </Button> */}
                      </Row>
                    }
                  >
                    <Descriptions.Item label={<b>State</b>} key="State">
                      {fixedIncomeRedemption.state ? (
                        <Tag
                          color={getStateColor(fixedIncomeRedemption.state)}
                          style={{ textTransform: "capitalize" }}
                        >
                          {formatSnakeCase(fixedIncomeRedemption.state)}
                        </Tag>
                      ) : (
                        "N/A"
                      )}
                    </Descriptions.Item>

                    <Descriptions.Item
                      label={<b>Total Redemption Amount</b>}
                      key="TotalRedemptionAmount"
                    >
                      {fixedIncomeRedemption.totalRedemptionAmount
                        ? formatter.format(
                            fixedIncomeRedemption.totalRedemptionAmount,
                          )
                        : "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item
                      label={<b>Fixed Income Request</b>}
                      key="FixedIncomeRequest"
                    >
                      {fixedIncomeRedemption?.fixedIncomeRequestId ? (
                        <NavLink
                          to={`/fixed-income-requests/${fixedIncomeRedemption.fixedIncomeRequestId}`}
                        >
                          View Request
                        </NavLink>
                      ) : (
                        "N/A"
                      )}
                    </Descriptions.Item>

                    {!isTreasuryBill && (
                      <Descriptions.Item label={<b>Penalty</b>} key="Penalty">
                        {fixedIncomeRedemption.penalty !== undefined
                          ? formatter.format(fixedIncomeRedemption.penalty)
                          : "N/A"}
                      </Descriptions.Item>
                    )}

                    {isTreasuryBill && (
                      <Descriptions.Item
                        label={<b>Service Cost</b>}
                        key="ServiceCost"
                      >
                        {formatter.format(fixedIncomeRedemption.serviceCost || 0)}
                      </Descriptions.Item>
                    )}

                    {isTreasuryBill && (
                      <Descriptions.Item
                        label={<b>CSD Charge</b>}
                        key="CsdCharge"
                      >
                        {formatter.format(fixedIncomeRedemption.csdCharge || 0)}
                      </Descriptions.Item>
                    )}

                    {isTreasuryBill &&
                      fixedIncomeRedemption.redemptionType === "partial" && (
                        <Descriptions.Item
                          label={<b>Remaining Balance</b>}
                          key="RemainingBalance"
                        >
                          {formatter.format(
                            fixedIncomeRedemption.remainingBalance || 0,
                          )}
                          {fixedIncomeRedemption.remainingTenor
                            ? ` for ${fixedIncomeRedemption.remainingTenor} days`
                            : ""}
                        </Descriptions.Item>
                      )}

                    {/* Before maturity a treasury bill redemption pays out cash after charges, so no interest is stored on it. */}
                    {!(
                      isTreasuryBill &&
                      (fixedIncomeRedemption.redemptionType === "partial" ||
                        fixedIncomeRedemption.redemptionTiming === "early")
                    ) && (
                      <Descriptions.Item
                        label={<b>Interest Earned</b>}
                        key="InterestEarned"
                      >
                        {fixedIncomeRedemption.interestEarned !== undefined
                          ? formatter.format(fixedIncomeRedemption.interestEarned)
                          : "N/A"}
                      </Descriptions.Item>
                    )}

                    <Descriptions.Item
                      label={<b>Redemption Type</b>}
                      key="RedemptionType"
                    >
                      {fixedIncomeRedemption.redemptionType
                        ? capitalizeFirstLetter(
                            fixedIncomeRedemption.redemptionType,
                          )
                        : "N/A"}
                    </Descriptions.Item>

                    {!isTreasuryBill && (
                      <Descriptions.Item
                        label={<b>Redemption Timing</b>}
                        key="RedemptionTiming"
                      >
                        {fixedIncomeRedemption.redemptionTiming
                          ? capitalizeFirstLetter(
                              fixedIncomeRedemption.redemptionTiming,
                            )
                          : "N/A"}
                      </Descriptions.Item>
                    )}

                    <Descriptions.Item label={<b>Roll Over</b>} key="RollOver">
                      {fixedIncomeRedemption.rollOver !== undefined ? (
                        <Tag
                          color={
                            fixedIncomeRedemption.rollOver ? "green" : "red"
                          }
                        >
                          {fixedIncomeRedemption.rollOver ? "Yes" : "No"}
                        </Tag>
                      ) : (
                        "N/A"
                      )}
                    </Descriptions.Item>

                    {!isTreasuryBill && (
                      <Descriptions.Item
                        label={<b>Assigned To</b>}
                        key="AssignedTo"
                      >
                        {fixedIncomeRedemption.assignedTo?.name || "N/A"}
                      </Descriptions.Item>
                    )}

                    <Descriptions.Item label={<b>Reference</b>} key="Reference">
                      {fixedIncomeRedemption.reference || "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item
                      label={<b>Created On</b>}
                      key="createdAt"
                    >
                      {fixedIncomeRedemption.createdAt
                        ? moment(
                            fixedIncomeRedemption.createdAt,
                            "YYYY-MM-DD HH:mm:ss",
                          ).format("llll")
                        : "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item label={<b>Rolled Over Request</b>}>
                      {fixedIncomeRedemption?.rolledOverFixedIncomeRequest ? (
                        <NavLink
                          to={`/fixed-income-requests/${fixedIncomeRedemption?.rolledOverFixedIncomeRequest?.id}`}
                        >
                          View Request
                        </NavLink>
                      ) : (
                        "N/A"
                      )}
                    </Descriptions.Item>

                    <Descriptions.Item label={<b>Payment Method</b>}>
                      {fixedIncomeRedemption?.paymentMethod
                        ? formatSnakeCase(fixedIncomeRedemption.paymentMethod)
                        : "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item label={<b>Bank/Provider</b>}>
                      {fixedIncomeRedemption?.bankName || "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item label={<b>Account Name</b>}>
                      {fixedIncomeRedemption?.accountName || "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item label={<b>Account Number</b>}>
                      {fixedIncomeRedemption?.accountNumber || "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item label={<b>Supporting Document</b>}>
                      {fixedIncomeRedemption?.supportingDocumentUrl ? (
                        <a href={fixedIncomeRedemption.supportingDocumentUrl} target="_blank" rel="noopener noreferrer">
                          View Document
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                )}
              </Col>
            </Row>
          </Fragment>
        </Card>

        <div
          style={{
            margin: "25px 0",
            display: "flex",
            justifyContent: "start",
            gap: "10px",
          }}
        >
          <div style={{ display: "flex", gap: "5px" }}>
            {availableTransitionStates?.map((transition, i) => (
              <Button
                onClick={() => this.requestForReason(transition.state)}
                className={getStateButtonClass(transition.state)}
                id={`transition-btn-${i}`}
                key={i}
                disabled={isReasonLoading}
              >
                {generateStateButtonText(transition.event)}
              </Button>
            ))}
          </div>
        </div>

        {fixedIncomeRedemption?.allocationBreakdown && (
          <Card style={{ marginTop: 16 }}>
            <CalculatedBreakdownDisplay
              breakdown={fixedIncomeRedemption.allocationBreakdown}
              showExplanations={false}
            />
          </Card>
        )}

        {/* 
        {fixedIncomeRedemption && (
          <Collapse style={{ marginTop: 16 }}>
            <Collapse.Panel header="Notes" key="notes">
              <NotesSection
                showHeading={false}
                reference={this.reference}
                createNote={this.createNote}
                notes={notes}
                showForm={true}
                canCreateTicket={false}
                showTicketForm={showTicketForm}
                toggleTicketCreate={this.toggleCreateTicket}
                createTicket={this.createTicket}
                ticketLoading={isTicketCreateLoading}
                ticketReference={this.ticketReference}
                currentNote={currentNote}
                entity="FixedIncomeRedemption"
                onNoteUpdate={this.handleNoteUpdate}
              />
            </Collapse.Panel>
          </Collapse>
        )} */}

        <Drawer
          title={this.getTitleBasedOnDrawerContent()}
          width={1200}
          onClose={this.toggleDrawer("")}
          visible={showDrawer}
          bodyStyle={{ paddingBottom: 80 }}
          maskClosable={false}
        >
          {this.getDrawerContent()}
        </Drawer>
      </Spin>
    );
  }
}
